import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { StaffPayrollGroupService } from './staff-payroll-group.service';
import { PayrollGroupService } from '../payroll-group/payroll-group.service';
import { ShopPayrollSettingsService } from '../shop-payroll-settings/shop-payroll-settings.service';
import { FilterListItemModel, SearchParam, SearchFilterComponent } from 'src/app/common/components/search-filter/search-filter.component';
import { ShopPayrollSettingsModel } from '../shop-payroll-settings/model/shop-payroll-settings.model';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';

@Component({
  selector: 'app-staff-payroll-group',
  templateUrl: './staff-payroll-group.component.html',
  styleUrls: ['./staff-payroll-group.component.scss'],
  standalone: false
})
export class StaffPayrollGroupComponent implements OnInit, AfterViewInit {
  filterForm: FormGroup;
  payrollGroups: any[] = [];
  filteredPayrollGroups: any[] = [];
  shopPayrolls: any[] = [];
  filteredShopPayrolls: any[] = [];
  statusList = [
    { value: '1', label: 'Active' },
    { value: '2', label: 'Inactive' }
  ];
  filter: FilterListItemModel[] = [
    { title: "Code", column: "code" },
    { title: "Fixed Pay", column: "fixed_pay" },
    { title: "Payroll Code", column: "payroll_code" }
  ];
  pagingData = { length: 0, pageSize: 1000, pageIndex: 0 };
  searchColumFilter: SearchParam = {};
  displayedColumns: string[] = ['sl', 'code', 'name', 'fixed_pay', 'payroll_code', 'action'];
  dataSource = new MatTableDataSource<any>([]);
  isLoading = false;
  showValidation = false;
  searched = false;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;

  constructor(
    private fb: FormBuilder,
    private staffPayrollGroupService: StaffPayrollGroupService,
    private payrollGroupService: PayrollGroupService,
    private shopPayrollSettingsService: ShopPayrollSettingsService,
    private router: Router,
    private stateManagerService: StateManagerService
  ) {
    this.filterForm = this.fb.group({
      payroll_code: [null, Validators.required],
      shop_id: [null, Validators.required],
      status: ['1']
    });
  }

  ngOnInit(): void {
    this.loadDropdowns();

    // Do not call loadList() here
  }

  ngAfterViewInit(): void {
    this.loadPreviousState();
  }

  /**
   * loads the previous state if exists
   */
  // loadPreviousState(): void {
  //   const previousState = this.stateManagerService.getState(this.constructor.name);
  //   if (previousState !== undefined && this.searchFilter != undefined) {
  //     if (previousState.state.search.filters.scope) {
  //       this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
  //       this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
  //     }
  //     if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
  //       // Optionally set sort column if needed
  //       // this.sort.active = previousState.state.search.sort[0].column;
  //       // this.sort.direction = previousState.state.search.sort[0].order;
  //     }
  //     this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
  //     this.searchFilter.setSearchFilter(this.searchColumFilter, true);
  //     // Optionally restore filterForm values if you store them
  //   } else {
  //     // Optionally set default sort or load data
  //     // this.loadList();
  //   }
  // }
  loadPreviousState(): void {
    const previousState = this.stateManagerService.getState(this.constructor.name);
    console.log('Restored State:', previousState);

    if (previousState?.state?.search) {
      const search = previousState.state.search;

      // Restore paging
      if (search.filters?.scope) {
        this.pagingData.pageSize = search.filters.scope.limit;
        this.pagingData.pageIndex =
          search.filters.scope.offset / search.filters.scope.limit;
      }

      // Restore search filters
      this.searchColumFilter = JSON.parse(JSON.stringify(search.filters));

      // Restore filterForm values from advSearch if present
      let advSearch = search.filters?.advSearch || [];
      let shop_id = null;
      let status = null;
      advSearch.forEach((item: any) => {
        if (item.column === 'shop_id') shop_id = item.value;
        if (item.column === 'status') status = item.value;
      });

      // Patch filterForm values before loading list
      this.filterForm.patchValue({
        shop_id: shop_id !== undefined ? shop_id : null,
        status: status !== undefined ? status : '1'
      }, { emitEvent: false });

      // Mark controls as touched to trigger validation
      this.filterForm.get('payroll_code')?.markAsTouched();
      this.filterForm.get('shop_id')?.markAsTouched();

      // Delay until SearchFilterComponent is ready, then load list
      setTimeout(() => {
        if (this.searchFilter) {
          this.searchFilter.setSearchFilter(this.searchColumFilter, true);
        }
        this.loadList();
      });
    }
  }


  loadDropdowns() {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };
    this.payrollGroupService.getList(requestData).subscribe(res => {
      if (res.status === 'SUCCESS') {
        this.payrollGroups = res.data.payroll_groups || [];
        this.filteredPayrollGroups = this.payrollGroups.slice();
      }
    });
    this.shopPayrollSettingsService.getList(requestData).subscribe(res => {
      if (res.status === 'SUCCESS') {
        this.shopPayrolls = res.data.shop_payroll_settings || [];
        this.filteredShopPayrolls = this.shopPayrolls.slice();
      }
    });
  }

  filterPayrollGroups(value: string) {
    const filterValue = value ? value.toLowerCase() : '';
    this.filteredPayrollGroups = this.payrollGroups.filter(group =>
      group.code.toLowerCase().includes(filterValue)
    );
  }
  getPayrollGroupName(id: any): string {
    const found = this.payrollGroups.find(g => g.id === id);
    return found ? found.code : '';
  }

  displayPayrollGroup = (code: any): string => {
    const found = this.payrollGroups.find(g => g.code === code);
    return found ? found.code : '';
  }
  clearPayrollGroup() {
    this.filterForm.get('payroll_code')?.setValue(null);
    this.filteredPayrollGroups = this.payrollGroups.slice();
    this.filterForm.get('shop_id')?.setValue(null);
    // Reset filteredShopPayrolls to all shops when payroll group is cleared
    this.filteredShopPayrolls = this.shopPayrolls.slice();
  }
  selectPayrollGroup(id: any) {
    this.filterForm.get('payroll_code')?.setValue(id);
    this.showValidation = false;
    // Filter shops based on selected payroll group
    this.filterShopPayrolls('');
  }

  get selectedPayrollGroupCode(): string | null {
    const payroll_code = this.filterForm.get('payroll_code')?.value;
    if (!payroll_code) return null;
    // Find the payroll group by id or code
    let group = this.payrollGroups.find(g => g.id === payroll_code || g.code === payroll_code);
    return group ? group.code : null;
  }

  filterShopPayrolls(value: string) {
    const filterValue = value ? value.toLowerCase() : '';
    const selectedGroupCode = this.selectedPayrollGroupCode;
    this.filteredShopPayrolls = this.shopPayrolls.filter(shop => {
      // Only show shops where group_code matches selected payroll group code
      const matchesGroup = selectedGroupCode ? shop.group_code === selectedGroupCode : true;
      const matchesName = shop.name.toLowerCase().includes(filterValue);
      return matchesGroup && matchesName;
    });
  }
  getShopName(id: any): string {
    const found = this.shopPayrolls.find(s => s.shop_id === id);
    return found ? found.name : '';
  }
  clearShopPayroll() {
    this.filterForm.get('shop_id')?.setValue(null);
    // Reset filteredShopPayrolls based on selected payroll group
    this.filterShopPayrolls('');
  }
  // selectShopPayroll(id: any) {
  //   if (!this.filterForm.value.payroll_code) {
  //     this.showValidation = true;
  //     this.filterForm.get('shop_id')?.setValue(null);
  //     return;
  //   }
  //   this.filterForm.get('shop_id')?.setValue(id);
  //   this.showValidation = false;
  // }

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadList();
  }

  onePageEvent(event: any): void {
    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;
    this.loadList();
  }

  buildRequestData(): any {
    const { shop_id, status } = this.filterForm.value;
    let advSearch: any[] = [...(this.searchColumFilter.advSearch || [])];

    if (shop_id) advSearch.push({ column: 'shop_id', value: shop_id, operator: '=' });
    if (status) advSearch.push({ column: 'status', value: status, operator: '=' });

    return {
      search: {
        filters: {
          simpleSearch: this.searchColumFilter.freeSearch || [],
          advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize)
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
  }

  loadList() {
    this.searched = true;
    // Mark controls as touched to trigger validation
    this.filterForm.get('payroll_code')?.markAsTouched();
    this.filterForm.get('shop_id')?.markAsTouched();

    if (this.filterForm.invalid) {
      this.showValidation = true;
      this.dataSource.data = [];
      this.pagingData.length = 0;
      return;
    }
    this.isLoading = true;
    const requestData = this.buildRequestData();
    this.staffPayrollGroupService.getList(requestData).subscribe(res => {
      if (res.status === 'SUCCESS') {
        this.dataSource.data = res.data.staff_payroll_groups || [];
        if (this.sort) this.dataSource.sort = this.sort;
        this.pagingData.length = res.data.total_count || 0;
        // Store current requestData as state in session storage via StateManagerService
        // this.stateManagerService.setState(this.constructor.name, requestData);
        console.log('Saving State:', requestData);
        this.stateManagerService.setState(this.constructor.name, {
          state: {
            search: requestData.search
          }
        });

      } else {
        this.dataSource.data = [];
        this.pagingData.length = 0;
      }
      this.isLoading = false;
    });
  }
  onEdit(item: ShopPayrollSettingsModel): void {
    this.router.navigate(['payroll/staff-payroll-group-edit', item.id, item.shop_id]);
  }

  displayShopName = (id: any): string => {
    if (!id) {
      return '';
    }

    const found = this.shopPayrolls.find(
      shop => shop.shop_id === id
    );

    return found ? found.name : '';
  };


  selectShopPayroll(shop: any) {
    if (!this.filterForm.value.payroll_code) {
      this.showValidation = true;
      this.filterForm.get('shop_id')?.setValue(null);
      return;
    }

    // Store only the ID
    this.filterForm.get('shop_id')?.setValue(shop.shop_id);
    this.filterForm.get('shop_id')?.markAsTouched();
    this.showValidation = false;
  }

}


